"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppSelector = exports.useAppDispatch = exports.store = void 0;
const reducer_1 = __importDefault(require("@/app/SUMO/store/scheduler/reducer"));
const reducer_2 = __importDefault(require("@/app/SUMO/store/user/reducer"));
const reducer_3 = __importDefault(require("@/app/SUMOCEP/store/scheduler/reducer"));
const reducer_4 = __importDefault(require("@/app/SUMOCEP/store/user/reducer"));
const toolkit_1 = require("@reduxjs/toolkit");
const react_redux_1 = require("react-redux");
const redux_logger_1 = __importDefault(require("redux-logger"));
const redux_saga_1 = __importDefault(require("redux-saga"));
const reducer_5 = __importDefault(require("./global/reducer"));
const reducer_6 = __importDefault(require("./notifications/reducer"));
const rootSaga_1 = __importDefault(require("./rootSaga"));
const sagaMiddleware = (0, redux_saga_1.default)();
exports.store = (0, toolkit_1.configureStore)({
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(redux_logger_1.default, sagaMiddleware),
    reducer: {
        global: reducer_5.default,
        notifications: reducer_6.default,
        SUMO1_user: reducer_2.default,
        SUMO1_scheduler: reducer_1.default,
        SUMOCEP_user: reducer_4.default,
        SUMOCEP_scheduler: reducer_3.default,
    },
});
sagaMiddleware.run(rootSaga_1.default);
const useAppDispatch = () => (0, react_redux_1.useDispatch)();
exports.useAppDispatch = useAppDispatch;
exports.useAppSelector = react_redux_1.useSelector;
